import { keyframes, SxProps, Tooltip, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { secondsToHHMMSSFormat } from 'utils/secondsToMMSSFormat';

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

interface TimerProps {
  seconds: number;
  color: string | ((seconds: number) => string);
  hideTimerOnExpire?: boolean;
  sx?: SxProps;
  pulseOnEnding?: boolean;
  tooltipTitle?: string;
  ariaLabel?: string | ((seconds: number) => string);
}

const Timer = ({
  seconds,
  color,
  hideTimerOnExpire = false,
  sx,
  pulseOnEnding = false,
  tooltipTitle,
  ariaLabel,
}: TimerProps) => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (seconds <= 0 && hideTimerOnExpire) {
      setHidden(true);
    }
  }, [seconds]);

  if (hidden) return null;

  const getAriaLabelValue = () => {
    if (!ariaLabel) return '';
    if (typeof ariaLabel === 'string') return ariaLabel;
    return ariaLabel(seconds);
  };

  return (
    <Tooltip title={tooltipTitle}>
      <Typography
        aria-label={getAriaLabelValue()}
        sx={{
          paddingX: 1,
          paddingY: 0.5,
          borderRadius: 1,
          color: 'white',
          backgroundColor: typeof color === 'string' ? color : color(seconds),
          animation: pulseOnEnding && seconds < 10 ? `${pulse} 2s infinite` : null,
          ...sx,
        }}>
        {secondsToHHMMSSFormat(seconds)}
      </Typography>
    </Tooltip>
  );
};

export default Timer;
